import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';

import { ToggleSearch } from './toggle-search.action';

export function toggleSearchReducer(
    state: TaskListDialogState,
    _: PayloadAction<ActionType.TC__TL__TOGGLE_SEARCH, ToggleSearch>,
): TaskListDialogState {
    return {
        ...state,
        searchOpen: state.searchOpen !== true,
    };
}
